import { createFileRoute } from '@tanstack/react-router';

import { AdditionalServicesPage } from '@/areas/settings/manufacturing/Settings/AdditionalServicesPage/AdditionalServicesPage';
import { canViewCustomerPortalSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/settings/_menu/organization/customer-portal/additional-services',
)({
    staticData: {
        access: { permissions: canViewCustomerPortalSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <AdditionalServicesPage />;
}
